import LeftArrowIcon from '@assets/icons/chevron-left.svg?react'
import RightArrowIcon from '@assets/icons/chevron-right.svg?react'
import { breakpoints } from '@constants'
import { useMatchMedia } from 'mmfintech-commons'
import type { PaginationSetupData } from 'mmfintech-commons/types'
import { MMPagination as LibraryPagination } from 'mmfintech-portal-commons'

interface CustomProps {
  totalPages: number
  currentPage: number
  setCurrentPage: (data: PaginationSetupData) => void
  className?: string
  sort?: string
}

export const MMPagination = (props: CustomProps) => {
  const { setCurrentPage, sort, ...rest } = props

  const isLarge = useMatchMedia({ breakpoint: breakpoints.md, prefix: 'min' })

  function onPageChange(page: number) {
    setCurrentPage({ page, sort })
  }

  return (
    <LibraryPagination
      minPagesVisible={2}
      pageRangeDisplayed={isLarge ? 3 : 1}
      showPageLabel={false}
      showPrevNextButtons={true}
      setCurrentPage={onPageChange}
      previousIcon={LeftArrowIcon}
      nextIcon={RightArrowIcon}
      {...rest}
    />
  )
}
